import React from 'react'

import formatDate from "../../../gd/format/date"
import EntitySelectorItem from "./item"

type Props = {
    model: EntitySelectorItem
}

// The right-hand date column. `formatDate` with no format argument follows the
// viewer's own date setting, so the column reads the same as every other date
// in the product. A row with no date renders empty rather than a placeholder.
export default function EntitySelectorGlistDateCell(props: Props) {
    return (
        <div className="ui5-txt-default txt-truncate">
            {formatDate(props.model.date)}
        </div>
    )
}
